import { useSnapshot } from 'valtio';
import { authStore } from '../../../../store/authStore';
import { HostRatingsDashboard } from '../../../components/ratings';
import styled from 'styled-components';
import tw from 'twin.macro';

const Container = styled.div`
  ${tw`min-h-screen bg-bg-secondary`}
`;

const LoadingText = styled.p`
  ${tw`text-center py-8 text-text-secondary`}
`;

export default function RatingsPage() {
  const { user } = useSnapshot(authStore);

  if (!user?.id) {
    return (
      <Container>
        <LoadingText>Loading...</LoadingText>
      </Container>
    );
  }

  return (
    <Container>
      <HostRatingsDashboard hostId={user.id} />
    </Container>
  );
}
